import { CardLoader } from 'components/organisms'
import CheckoutPrice from 'domains/customer-checkout/molecules/price'
import withLoader from 'hocs/with-loader/with-loader'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

const propTypes = {
  order: PropTypes.shape({
    item_price_total          : PropTypes.number,
    item_discount_total       : PropTypes.number,
    shipment_cost_total       : PropTypes.number,
    shipment_insurance_total  : PropTypes.number,
    shipment_discount_total   : PropTypes.number,
    payment_method_rate_total : PropTypes.number,
    total                     : PropTypes.number
  })
}

const defaultProps = {
  order: {
    item_price_total          : 0,
    item_discount_total       : 0,
    shipment_cost_total       : 0,
    shipment_insurance_total  : 0,
    shipment_discount_total   : 0,
    payment_method_rate_total : 0,
    total                     : 0
  }
}

const CustomerCheckoutTotalSection = ({
  order
}) => (
  <>
    <Card className='shadow p-3 mb-3'>
      <div className='small'>

        <div className='d-flex flex-column'>
          <div className='d-flex justify-content-between'>
            <strong className='text-gray'>ITEM SUBTOTAL</strong>
            <CheckoutPrice price={ order?.item_price_total || 0 }/>
          </div>
        </div>

        <div className='d-flex justify-content-between align-items-center'>
          <strong className='text-gray'>DELIVERY FEE</strong>
          {
            order?.shipment_cost_total > 0
              ? <CheckoutPrice price={ order?.shipment_cost_total || 0 } />
              : <span className='small text-danger'>Belum Pilih</span>
          }
        </div>

        {
          order?.shipment_insurance_total > 0 && (
            <div className='d-flex justify-content-between'>
              <strong className='text-gray'>{ 'SHIPPING INSURANCE' }</strong>
              <CheckoutPrice price={ order?.shipment_insurance_total || 0 } />
            </div>
          )
        }

        {
          order?.payment_method_rate_total > 0 && (
            <div className='d-flex justify-content-between'>
              <strong className='text-gray'>CONVENIENCE FEE</strong>
              <CheckoutPrice price={ order?.payment_method_rate_total || 0 } />
            </div>
          )
        }
        {
          // negative value
          order?.item_discount_total < 0 && (
            <div className='d-flex justify-content-between'>
              <strong className='text-gray'>ITEM DISCOUNT</strong>
              <CheckoutPrice price={ order?.item_discount_total || 0 } />
            </div>
          )
        }
        {
          // negative value
          order?.shipment_discount_total < 0 && (
            <div className='d-flex justify-content-between'>
              <strong className='text-gray'>SHIPMENT DISCOUNT</strong>
              <CheckoutPrice price={ order?.shipment_discount_total || 0 } />
            </div>
          )
        }
      </div>

      <hr/>

      <div className='d-flex justify-content-between'>
        <strong className='text-gray'>TOTAL</strong>
        <CheckoutPrice price={ order?.total || 0 } />
      </div>

    </Card>
  </>
)

CustomerCheckoutTotalSection.propTypes    = propTypes
CustomerCheckoutTotalSection.defaultProps = defaultProps

export default withLoader(CustomerCheckoutTotalSection, CardLoader)